import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './machine_css.css';
import { fadePages, pageTransition } from '../items/style/animationstyle';
import logger from '../services/LocalServer/logger';
import localRequest from '../services/LocalServer/localRequest';

export default function OutOfOrder(props) {
  useEffect(() => {
    logger(0, `going into OOS`);
    localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/resetStatus`,
      data: {},
    }).then(() => {});
  }, []);

  return (
    <motion.div
      className="home"
      exit="out"
      initial="innitial"
      animate="in"
      variants={fadePages}
      transition={pageTransition}
    >
      <div
        className="d-flex"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h1 className="thank-you-text">Sorry,</h1>
        <h1 style={{ width: '75%' }} className="thank-you-text">
          this machine is temporarily out of service
        </h1>
        {/* <ErrorOutline className="svg-style mt-3" style={{ height: '400px' }} /> */}
      </div>
    </motion.div>
  );
}
